if (!customElements.get('ci-portfolio')) customElements.define('ci-portfolio', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    const filters = this.querySelector('.ci-portfolio__filters');
    const works = [...this.querySelectorAll('[data-work]')];
    const categories = work => (work.dataset.categories || '').split(/\s+/);
    const gallery = this.querySelector('[data-gallery]');
    const status = this.querySelector('[data-filter-status]');
    const updateCount = () => { gallery.dataset.visibleCount = String(works.filter(w => !w.hidden).length); };
    filters.querySelectorAll('[data-filter]').forEach(b => {
      b.disabled = b.dataset.filter !== 'all' && !works.some(w => categories(w).includes(b.dataset.filter));
    });
    updateCount(); filters.hidden = false;
    filters.addEventListener('click', e => {
      const button = e.target.closest('[data-filter]');
      if (!button || button.disabled) return;
      filters.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      works.forEach(w => w.hidden = button.dataset.filter !== 'all' && !categories(w).includes(button.dataset.filter));
      gallery.dataset.filtered = String(button.dataset.filter !== 'all');
      updateCount();
      status.textContent = status.dataset.countLabel.replace('[count]', gallery.dataset.visibleCount);
    }, { signal });
    const dialog = this.querySelector('.ci-portfolio__lightbox');
    let opener = null, oldOverflow;
    this.querySelectorAll('[data-expand]').forEach(a => a.addEventListener('click', e => {
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
      e.preventDefault(); opener = a;
      const img = dialog.querySelector('img'); img.src = a.href; img.alt = a.querySelector('img').alt;
      oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden'; dialog.showModal();
    }, { signal }));
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close(), { signal });
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    }, { signal });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = oldOverflow || ''; opener?.focus({ preventScroll: true });
    }, { signal });
    this.restore = () => { if (dialog.open) { dialog.close(); document.documentElement.style.overflow = oldOverflow || ''; } };
    const track = this.querySelector('.ci-portfolio__video-track');
    if (!track) return;
    const controls = this.querySelector('.ci-portfolio__motion-controls');
    const prev = controls.querySelector('[data-video-prev]'), next = controls.querySelector('[data-video-next]');
    controls.hidden = false;
    const updateArrows = () => { prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; };
    const move = direction => {
      const step = track.querySelector('figure').getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
      track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    prev.addEventListener('click', () => move(-1), { signal }); next.addEventListener('click', () => move(1), { signal });
    track.addEventListener('scroll', updateArrows, { signal, passive: true });
    track.addEventListener('keydown', e => { if (e.target === track && ['ArrowLeft', 'ArrowRight'].includes(e.key)) { e.preventDefault(); move(e.key === 'ArrowRight' ? 1 : -1); } }, { signal });
    this.resizeObserver = new ResizeObserver(updateArrows); this.resizeObserver.observe(track); updateArrows();
  }
  disconnectedCallback() { this.restore?.(); this.abort?.abort(); this.videoObserver?.disconnect(); this.resizeObserver?.disconnect(); }
});
